// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== DELETE ACCOUNT STYLES ====================
   Prefix: da- to avoid collisions
   ============================================================= */

   .da-root {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  /* ── Title ─────────────────────────────────────────────────────── */
  .da-title {
    color: #ef5350 !important;
  }
  
  /* ── Steps ─────────────────────────────────────────────────────── */
  .da-step {
    display: flex;
    flex-direction: column;
    gap: 20px;
    animation: da-fadeIn 0.25s ease;
  }
  
  @keyframes da-fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0);   }
  }
  
  /* ── Danger Banner ─────────────────────────────────────────────── */
  .da-danger-banner {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 18px 20px;
    background: linear-gradient(135deg, rgba(244, 67, 54, 0.12) 0%, rgba(244, 67, 54, 0.06) 100%);
    border: 1px solid rgba(244, 67, 54, 0.30);
    border-left: 4px solid #ef5350;
    border-radius: 12px;
  }
  
  .da-danger-banner-icon {
    font-size: 1.8rem;
    flex-shrink: 0;
    margin-top: 1px;
  }
  
  .da-danger-banner-title {
    font-size: 14px;
    font-weight: 700;
    color: #ef9a9a;
    margin: 0 0 5px 0;
    padding: 0;
  }
  
  .da-danger-banner-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.60);
    margin: 0;
    padding: 0;
    line-height: 1.60;
  }
  
  .da-danger-banner-desc strong {
    color: #ef9a9a;
    font-weight: 700;
  }
  
  /* ── Consequences List ─────────────────────────────────────────── */
  .da-consequences {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 12px;
    padding: 18px 20px;
  }
  
  .da-consequences-title {
    font-size: 13px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.70);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 14px 0;
    padding: 0;
  }
  
  .da-consequences-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .da-consequence-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 10px;
    border-radius: 8px;
    background: rgba(244, 67, 54, 0.04);
    border: 1px solid rgba(244, 67, 54, 0.08);
    transition: all 0.15s ease;
  }
  
  .da-consequence-item:hover {
    background: rgba(244, 67, 54, 0.08);
    border-color: rgba(244, 67, 54, 0.15);
  }
  
  .da-consequence-icon {
    font-size: 1.1rem;
    flex-shrink: 0;
    margin-top: 1px;
  }
  
  .da-consequence-text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.60);
    line-height: 1.5;
  }
  
  /* ── Account Summary ───────────────────────────────────────────── */
  .da-account-summary {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 16px 20px;
  }
  
  .da-account-summary-title {
    font-size: 13px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.60);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 12px 0;
    padding: 0;
  }
  
  .da-account-summary-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .da-account-summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  
  .da-account-summary-row:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  
  .da-account-summary-key {
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.40);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  
  .da-account-summary-val {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.80);
  }
  
  /* ── Step Actions ──────────────────────────────────────────────── */
  .da-step-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 6px;
  }
  
  .da-step-actions--split {
    justify-content: space-between;
  }
  
  /* ── Buttons ───────────────────────────────────────────────────── */
  .da-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 11px 22px;
    border-radius: 8px;
    border: 1px solid transparent;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.18s ease;
    outline: none;
  }
  
  .da-btn--proceed {
    background: rgba(244, 67, 54, 0.12);
    border-color: rgba(244, 67, 54, 0.30);
    color: #ef9a9a;
  }
  
  .da-btn--proceed:hover {
    background: rgba(244, 67, 54, 0.20);
    border-color: rgba(244, 67, 54, 0.50);
    color: #fff;
    transform: translateY(-1px);
  }
  
  .da-btn--back {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.10);
    color: rgba(255, 255, 255, 0.55);
  }
  
  .da-btn--back:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.18);
    color: rgba(255, 255, 255, 0.85);
  }
  
  .da-btn--delete {
    background: #c62828;
    border-color: #b71c1c;
    color: #fff;
    box-shadow: 0 2px 12px rgba(198, 40, 40, 0.30);
  }
  
  .da-btn--delete:hover:not(.da-btn--disabled) {
    background: #d32f2f;
    border-color: #c62828;
    box-shadow: 0 4px 16px rgba(198, 40, 40, 0.45);
    transform: translateY(-1px);
  }
  
  .da-btn--disabled {
    opacity: 0.38;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  .da-btn-spinner {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  
  /* ── Confirm Box (Step 2) ──────────────────────────────────────── */
  .da-confirm-box {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(244, 67, 54, 0.15);
    border-radius: 14px;
    padding: 28px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 14px;
  }
  
  .da-confirm-icon {
    font-size: 3rem;
    line-height: 1;
  }
  
  .da-confirm-title {
    font-size: 18px;
    font-weight: 700;
    color: #ef9a9a;
    margin: 0;
    padding: 0;
  }
  
  .da-confirm-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
    padding: 0;
    line-height: 1.65;
    max-width: 480px;
  }
  
  .da-confirm-keyword {
    background: rgba(244, 67, 54, 0.15);
    border: 1px solid rgba(244, 67, 54, 0.30);
    color: #ef9a9a;
    font-weight: 800;
    font-family: monospace;
    letter-spacing: 0.08em;
    padding: 1px 6px;
    border-radius: 4px;
  }
  
  .da-confirm-input-wrapper {
    position: relative;
    width: 100%;
    max-width: 340px;
  }
  
  .da-confirm-input {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 40px 12px 16px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
    font-family: monospace;
    font-weight: 700;
    letter-spacing: 0.08em;
    outline: none;
    text-align: center;
    transition: all 0.18s ease;
  }
  
  .da-confirm-input:focus {
    border-color: rgba(244, 67, 54, 0.40);
    background: rgba(255, 255, 255, 0.06);
    box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.10);
  }
  
  .da-confirm-input--valid {
    border-color: rgba(76, 175, 80, 0.50) !important;
    background: rgba(76, 175, 80, 0.06) !important;
    color: #81c784 !important;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.10) !important;
  }
  
  .da-confirm-input-check {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #81c784;
    font-size: 1.1rem;
    font-weight: 700;
  }
  
  .da-confirm-hint {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.35);
    margin: 0;
    padding: 0;
  }
  
  .da-confirm-hint strong {
    color: #ef9a9a;
    font-family: monospace;
    letter-spacing: 0.08em;
  }
  
  /* ── Profile Warning ───────────────────────────────────────────── */
  .da-profiles-warning {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 16px;
    background: rgba(255, 152, 0, 0.08);
    border: 1px solid rgba(255, 152, 0, 0.20);
    border-radius: 9px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.60);
  }
  
  .da-profiles-warning span:first-child {
    font-size: 1.1rem;
    flex-shrink: 0;
  }
  
  .da-profiles-warning p {
    margin: 0;
    padding: 0;
    line-height: 1.55;
  }
  
  .da-profiles-warning strong {
    color: #ffb74d;
  }
  
  .da-profile-tag {
    color: rgba(255, 255, 255, 0.75);
    font-weight: 600;
  }
  
  /* ── Responsive ────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .da-danger-banner {
      flex-direction: column;
      gap: 10px;
    }
  
    .da-confirm-box {
      padding: 20px 16px;
    }
  
    .da-confirm-title {
      font-size: 16px;
    }
  
    .da-step-actions--split {
      flex-direction: column-reverse;
      gap: 10px;
    }
  
    .da-btn {
      width: 100%;
      justify-content: center;
    }
  
    .da-account-summary-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
  
  @media (max-width: 480px) {
    .da-consequences {
      padding: 14px 16px;
    }
  
    .da-consequence-item {
      padding: 6px 8px;
    }
  
    .da-consequence-text {
      font-size: 12px;
    }
  
    .da-confirm-input {
      font-size: 13px;
      padding: 10px 36px 10px 14px;
    }
  
    .da-btn {
      padding: 10px 18px;
      font-size: 13px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/DeleteAccount.css"],"names":[],"mappings":"AAAA;;kEAEkE;;GAE/D;IACC,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA,qEAAqE;EACrE;IACE,yBAAyB;EAC3B;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;EACjC;;EAEA;IACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;EACjD;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,6FAA6F;IAC7F,yCAAyC;IACzC,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,yCAAyC;IACzC,0BAA0B;EAC5B;;EAEA;IACE,mCAAmC;IACnC,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,kDAAkD;EACpD;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA,qEAAqE;EACrE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,qCAAqC;IACrC,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA,qEAAqE;EACrE;IACE,qCAAqC;IACrC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,qCAAqC;IACrC,6CAA6C;EAC/C;;EAEA;IACE,gDAAgD;IAChD,8CAA8C;IAC9C,yBAAyB;IACzB,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,8BAA8B;MAC9B,SAAS;IACX;;IAEA;MACE,WAAW;MACX,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;IACV;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,4BAA4B;IAC9B;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF","sourcesContent":["/* ==================== DELETE ACCOUNT STYLES ====================\n   Prefix: da- to avoid collisions\n   ============================================================= */\n\n   .da-root {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  /* ── Title ─────────────────────────────────────────────────────── */\n  .da-title {\n    color: #ef5350 !important;\n  }\n  \n  /* ── Steps ─────────────────────────────────────────────────────── */\n  .da-step {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    animation: da-fadeIn 0.25s ease;\n  }\n  \n  @keyframes da-fadeIn {\n    from { opacity: 0; transform: translateY(6px); }\n    to   { opacity: 1; transform: translateY(0);   }\n  }\n  \n  /* ── Danger Banner ─────────────────────────────────────────────── */\n  .da-danger-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    padding: 18px 20px;\n    background: linear-gradient(135deg, rgba(244, 67, 54, 0.12) 0%, rgba(244, 67, 54, 0.06) 100%);\n    border: 1px solid rgba(244, 67, 54, 0.30);\n    border-left: 4px solid #ef5350;\n    border-radius: 12px;\n  }\n  \n  .da-danger-banner-icon {\n    font-size: 1.8rem;\n    flex-shrink: 0;\n    margin-top: 1px;\n  }\n  \n  .da-danger-banner-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #ef9a9a;\n    margin: 0 0 5px 0;\n    padding: 0;\n  }\n  \n  .da-danger-banner-desc {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.60);\n    margin: 0;\n    padding: 0;\n    line-height: 1.60;\n  }\n  \n  .da-danger-banner-desc strong {\n    color: #ef9a9a;\n    font-weight: 700;\n  }\n  \n  /* ── Consequences List ─────────────────────────────────────────── */\n  .da-consequences {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 12px;\n    padding: 18px 20px;\n  }\n  \n  .da-consequences-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.70);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin: 0 0 14px 0;\n    padding: 0;\n  }\n  \n  .da-consequences-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .da-consequence-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    background: rgba(244, 67, 54, 0.04);\n    border: 1px solid rgba(244, 67, 54, 0.08);\n    transition: all 0.15s ease;\n  }\n  \n  .da-consequence-item:hover {\n    background: rgba(244, 67, 54, 0.08);\n    border-color: rgba(244, 67, 54, 0.15);\n  }\n  \n  .da-consequence-icon {\n    font-size: 1.1rem;\n    flex-shrink: 0;\n    margin-top: 1px;\n  }\n  \n  .da-consequence-text {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.60);\n    line-height: 1.5;\n  }\n  \n  /* ── Account Summary ───────────────────────────────────────────── */\n  .da-account-summary {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    padding: 16px 20px;\n  }\n  \n  .da-account-summary-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.60);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin: 0 0 12px 0;\n    padding: 0;\n  }\n  \n  .da-account-summary-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .da-account-summary-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  }\n  \n  .da-account-summary-row:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n  \n  .da-account-summary-key {\n    font-size: 12px;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.40);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n  \n  .da-account-summary-val {\n    font-size: 13px;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.80);\n  }\n  \n  /* ── Step Actions ──────────────────────────────────────────────── */\n  .da-step-actions {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 6px;\n  }\n  \n  .da-step-actions--split {\n    justify-content: space-between;\n  }\n  \n  /* ── Buttons ───────────────────────────────────────────────────── */\n  .da-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 11px 22px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    font-size: 13.5px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.18s ease;\n    outline: none;\n  }\n  \n  .da-btn--proceed {\n    background: rgba(244, 67, 54, 0.12);\n    border-color: rgba(244, 67, 54, 0.30);\n    color: #ef9a9a;\n  }\n  \n  .da-btn--proceed:hover {\n    background: rgba(244, 67, 54, 0.20);\n    border-color: rgba(244, 67, 54, 0.50);\n    color: #fff;\n    transform: translateY(-1px);\n  }\n  \n  .da-btn--back {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.10);\n    color: rgba(255, 255, 255, 0.55);\n  }\n  \n  .da-btn--back:hover {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.18);\n    color: rgba(255, 255, 255, 0.85);\n  }\n  \n  .da-btn--delete {\n    background: #c62828;\n    border-color: #b71c1c;\n    color: #fff;\n    box-shadow: 0 2px 12px rgba(198, 40, 40, 0.30);\n  }\n  \n  .da-btn--delete:hover:not(.da-btn--disabled) {\n    background: #d32f2f;\n    border-color: #c62828;\n    box-shadow: 0 4px 16px rgba(198, 40, 40, 0.45);\n    transform: translateY(-1px);\n  }\n  \n  .da-btn--disabled {\n    opacity: 0.38;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n  \n  .da-btn-spinner {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  /* ── Confirm Box (Step 2) ──────────────────────────────────────── */\n  .da-confirm-box {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(244, 67, 54, 0.15);\n    border-radius: 14px;\n    padding: 28px 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 14px;\n  }\n  \n  .da-confirm-icon {\n    font-size: 3rem;\n    line-height: 1;\n  }\n  \n  .da-confirm-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #ef9a9a;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .da-confirm-desc {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.55);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n    max-width: 480px;\n  }\n  \n  .da-confirm-keyword {\n    background: rgba(244, 67, 54, 0.15);\n    border: 1px solid rgba(244, 67, 54, 0.30);\n    color: #ef9a9a;\n    font-weight: 800;\n    font-family: monospace;\n    letter-spacing: 0.08em;\n    padding: 1px 6px;\n    border-radius: 4px;\n  }\n  \n  .da-confirm-input-wrapper {\n    position: relative;\n    width: 100%;\n    max-width: 340px;\n  }\n  \n  .da-confirm-input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 12px 40px 12px 16px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    color: #fff;\n    font-size: 14px;\n    font-family: monospace;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    outline: none;\n    text-align: center;\n    transition: all 0.18s ease;\n  }\n  \n  .da-confirm-input:focus {\n    border-color: rgba(244, 67, 54, 0.40);\n    background: rgba(255, 255, 255, 0.06);\n    box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.10);\n  }\n  \n  .da-confirm-input--valid {\n    border-color: rgba(76, 175, 80, 0.50) !important;\n    background: rgba(76, 175, 80, 0.06) !important;\n    color: #81c784 !important;\n    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.10) !important;\n  }\n  \n  .da-confirm-input-check {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #81c784;\n    font-size: 1.1rem;\n    font-weight: 700;\n  }\n  \n  .da-confirm-hint {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.35);\n    margin: 0;\n    padding: 0;\n  }\n  \n  .da-confirm-hint strong {\n    color: #ef9a9a;\n    font-family: monospace;\n    letter-spacing: 0.08em;\n  }\n  \n  /* ── Profile Warning ───────────────────────────────────────────── */\n  .da-profiles-warning {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 12px 16px;\n    background: rgba(255, 152, 0, 0.08);\n    border: 1px solid rgba(255, 152, 0, 0.20);\n    border-radius: 9px;\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.60);\n  }\n  \n  .da-profiles-warning span:first-child {\n    font-size: 1.1rem;\n    flex-shrink: 0;\n  }\n  \n  .da-profiles-warning p {\n    margin: 0;\n    padding: 0;\n    line-height: 1.55;\n  }\n  \n  .da-profiles-warning strong {\n    color: #ffb74d;\n  }\n  \n  .da-profile-tag {\n    color: rgba(255, 255, 255, 0.75);\n    font-weight: 600;\n  }\n  \n  /* ── Responsive ────────────────────────────────────────────────── */\n  @media (max-width: 768px) {\n    .da-danger-banner {\n      flex-direction: column;\n      gap: 10px;\n    }\n  \n    .da-confirm-box {\n      padding: 20px 16px;\n    }\n  \n    .da-confirm-title {\n      font-size: 16px;\n    }\n  \n    .da-step-actions--split {\n      flex-direction: column-reverse;\n      gap: 10px;\n    }\n  \n    .da-btn {\n      width: 100%;\n      justify-content: center;\n    }\n  \n    .da-account-summary-row {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 4px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .da-consequences {\n      padding: 14px 16px;\n    }\n  \n    .da-consequence-item {\n      padding: 6px 8px;\n    }\n  \n    .da-consequence-text {\n      font-size: 12px;\n    }\n  \n    .da-confirm-input {\n      font-size: 13px;\n      padding: 10px 36px 10px 14px;\n    }\n  \n    .da-btn {\n      padding: 10px 18px;\n      font-size: 13px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
